import SettingsIcon from "@mui/icons-material/Settings";
import { CheckboxWithHelperText, FlexColumn, FlexRowCenter, Text, ToggleButton } from "designSystem/index";
import { grey } from "designSystem/styles/color";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { SalesRegionException } from "./SalesRegionException";
import BaseCompositionRightDrawerMainText from "./BaseCompositionRightDrawerMainText";

interface BaseCompositionRightDrawerProps { 
	salesRegionException: SalesRegionException;
}

const BaseCompositionRightDrawer: FunctionComponent<BaseCompositionRightDrawerProps> = observer(function BaseCompositionRightDrawer({ salesRegionException }) {
	const {
		includeCompositionPlacementNames,
		compositionPlacements,
		allNestUnderContainsPlacements,
		combineSameCompositionMaterials,
		includeCompositionTypes,
		name,
		showSettings,
		setShowSettings,
		setIncludeCompositionPlacementNames,
		setCombineSameCompositionMaterials,
		setIncludeCompositionTypes,
	} = salesRegionException;

	return (
		<FlexColumn
			flexGrow={1}
			maxHeight="100%"
			width="100%"
		>
			<FlexRowCenter
				borderBottom={1}
				borderColor={grey[400]}
				data-csi-automation="PreviewSettings"
				justifyContent="space-between"
				paddingX={4}
				paddingY={2}
				width="100%"
			>
				<Text
					data-csi-automation="text-PreviewSettings"
					res="CareAndCompPreview"
					resParams={[name]}
					semiBold
					size={14}
				/>
				<ToggleButton
					onClick={setShowSettings}
					selected={showSettings}
					value="showSettings"
				>
					<SettingsIcon
						sx={{ fontSize: "1.5em" }}
					/>
				</ToggleButton>
			</FlexRowCenter>
			{showSettings && (
				<FlexColumn
					bgcolor={grey[50]}
					borderBottom={1}
					borderColor={grey[400]}
					maxHeight="100%"
					paddingX={4}
					paddingY={3}
				>
					<Text
						res="CareAndCompPreviewSettings"
						semiBold
						size={12}
						sx={{ paddingBottom: 3 }}
					/>
					<CheckboxWithHelperText
						helperTextRes="CareAndCompRightDrawerPlacementCheckboxHelper"
						isChecked={includeCompositionPlacementNames}
						mainTextSemiBold
						onChange={setIncludeCompositionPlacementNames}
						res="CareAndCompRightDrawerPlacementCheckboxMain"
					/>
					<CheckboxWithHelperText
						helperTextRes="CareAndCompRightDrawerCombineCompositionsCheckboxHelper"
						isChecked={combineSameCompositionMaterials}
						mainTextSemiBold
						onChange={setCombineSameCompositionMaterials}
						res="CareAndCompRightDrawerCombineCompositionsCheckboxMain"
					/>
					<CheckboxWithHelperText
						helperTextRes="CareAndCompRightDrawerCompositionTypeCheckboxHelper"
						isChecked={includeCompositionTypes}
						mainTextSemiBold
						onChange={setIncludeCompositionTypes}
						res="CareAndCompRightDrawerCompositionTypeCheckboxMain"
					/>
				</FlexColumn>
			)}
			<FlexColumn
				maxHeight="100%"
				overflow="auto"
				paddingY={3}
			>
				{compositionPlacements?.map((placement, index) => (
					<BaseCompositionRightDrawerMainText 
						data-csi-automation="CompositionPlacementPreview"
						placement={placement} 
						salesRegionException={salesRegionException}
					/>
				))}
				{allNestUnderContainsPlacements.length > 0 && (
					<FlexColumn
						gap={4}
						paddingX={4}
						paddingY={3}
					>
						<Text
							bold
							res="CareAndCompContain"
							size={14}
						/>
						<FlexColumn gap={2}>
							{allNestUnderContainsPlacements.map((materialText) => (
								<Text
									size={12}
									text={materialText}
								/>
							))}
						</FlexColumn>
					</FlexColumn>
				)}
			</FlexColumn>
		</FlexColumn>
	);
});

export default BaseCompositionRightDrawer;